/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from "react";
import Discuss from "parts/Discuss";
import Button from "elements/Button";
import BenefitsSection from "components/BenefitsSection";

export default function CloudSolutions() {
  return (
    <>
      {/* FEATURES */}
      <section className="py-20 bg-premium-light">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-surface-900 font-extrabold text-center mb-6 tracking-tight">
            What we do
          </h2>
          <p className="text-center text-surface-300 text-lg mb-12">
            From lift-and-shift migrations to cloud-native platform engineering, our team
            builds resilient, secure and cost-optimised cloud environments.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Cloud Migration
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Seamless migration plans, minimal downtime and validated rollbacks — public, private and hybrid.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Managed Cloud Operations
              </h3>
              <p className="text-surface-300 leading-relaxed">
                24/7 monitoring, cost optimisation, patching and backups so your cloud runs reliably.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Cloud Security & Compliance
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Identity, encryption, network segmentation and compliance controls tailored to your industry.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION (Reusable) */}
      <BenefitsSection
        title="Why move to the cloud with us?"
        subtitle="We design cloud platforms that balance performance, security, and cost efficiency."
        benefits={[
          {
            id: "predictable-costs",
            title: "Predictable costs",
            text: "Right-size your environment and reduce wasted spend with ongoing cost governance.",
            delay: 0,
          },
          {
            id: "reliability",
            title: "Improved reliability",
            text: "Architect for high availability, backups and automated recoveries.",
            delay: 120,
          },
          {
            id: "security-design",
            title: "Security by design",
            text: "Secure-by-default configurations and continuous monitoring reduce risk and meet compliance needs.",
            delay: 240,
          },
        ]}
        gainsTitle="Typical outcomes"
        gains={[
          { id: "deployments", text: "30–60% faster deployments" },
          { id: "costs", text: "Lowered infrastructure costs with rightsizing & reserved instances" },
          { id: "posture", text: "Improved security posture via automated compliance checks" },
        ]}
      />

      {/* CTA SECTION */}
      <section className="py-20 bg-premium-accent">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-surface-900 font-extrabold tracking-tight">
              Ready to move to the cloud?
            </h2>
            <p className="text-surface-300 mt-2 text-lg">
              Book a free assessment and roadmap — we’ll show you the fastest, safest path forward.
            </p>
          </div>

          <Button
            href="/contact"
            type="link"
            className="btn-premium text-base px-8 py-4"
          >
            Book a Consultation
          </Button>
        </div>
      </section>

      <Discuss />
    </>
  );
}
